import * as Sentry from '@sentry/react';
/*global window */

const setupSentry = () => {
  if (import.meta.env.PROD) {
    Sentry.init({
      dsn: 'https://de0fba07a7d64086a7da204e2b64c06e@o38063.ingest.sentry.io/129114',
      allowUrls: [/secure\.collage\.co/, /assets-secure\.collage\.co\/.*\.js/],
      ignoreErrors: [
        'Request failed with status code',
        'Network Error',
        'timeout of 0ms exceeded',
        'Request aborted',
        'Illegal invocation'
      ],
      release: window.release
    });

    if (window.auth) {
      let user = {...window.auth.user};
      let tags = {
        user_id: window.auth.user.id
      };

      if (window.auth.company) {
        user = {
          ...user,
          companyId: window.auth.company.id,
          companyName: window.auth.company.name
        };

        tags = {
          ...tags,
          company_id: window.auth.company.id,
          company_name: window.auth.company.name,
        };
      }

      Sentry.setUser(user);
      Sentry.setTags(tags);
    }
  }
};

export default setupSentry;
